import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../molecules/switch-box';
import { ValueBox } from '../../molecules/value-box';
import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';

const MqttCloud = () => {
  const [serviceActive, connected] = useSelector(
    ({ variables }) =>
      [variables.SERVICE_ACTIVE, variables.MQTT_CLOUD_CONNECTED] as const
  );

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage id="mqtt_cloud.title" defaultMessage="MQTT Cloud" />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={
          <FormattedMessage id="mqtt_cloud.title" defaultMessage="MQTT Cloud" />
        }
      >
        <SwitchBox
          switchVariableId="MQTT_CLOUD_ENABLED"
          title={
            <FormattedMessage
              id="mqtt_cloud.enabled"
              defaultMessage="Integrace zapnuta"
            />
          }
          fullWidth
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage id="mqtt_cloud.connected" defaultMessage="Stav" />
          }
          value={
            connected ? (
              <FormattedMessage
                id="mqtt_cloud.connected.online"
                defaultMessage="Online"
              />
            ) : (
              <FormattedMessage
                id="mqtt_cloud.connected.offline"
                defaultMessage="Offline"
              />
            )
          }
        />
      </Group>
    </>
  );
};

export default MqttCloud;
